const getBuildDate = () => {
    // Just return the complete version from environment or generate timestamp
    const envVersion = process.env.REACT_APP_VERSION;
    if (envVersion) {
        return envVersion; // Complete version from deploy script
    }

    // Local fallback: generate timestamp only
    const today = new Date();
    const day = today.getDate().toString().padStart(2, '0');
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const year = today.getFullYear();
    const hours = today.getHours().toString().padStart(2, '0');
    const minutes = today.getMinutes().toString().padStart(2, '0');

    return `Platform.V10.0.0.${day}${month}${year}.${hours}${minutes}`;
};

export const VERSION_INFO = {
    get fullVersion() {
        return getBuildDate(); // Just return the complete version
    }
};